module.exports = __webpack_public_path__ + "static/media/image.94117798.png";